"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformStringSingularIntoPlural = void 0;
function transformStringSingularIntoPlural({ data, value, }) {
    let valueString = '';
    value.forEach((quant, index) => {
        if (quant === 0)
            return;
        const newName = quant < 2
            ? data[index].name.toLowerCase()
            : `${data[index].name.toLowerCase().replace(/ /, 's ')}s`;
        valueString += `${quant} ${newName}, `;
    });
    return valueString.slice(0, -2);
}
exports.transformStringSingularIntoPlural = transformStringSingularIntoPlural;
//# sourceMappingURL=index.js.map